import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("SUBSCRIPTION/LOAD_ALL");
export const loadOne = createRoutine("SUBSCRIPTION/LOAD_ONE");
export const create = createRoutine("SUBSCRIPTION/CREATE");
export const update = createRoutine("SUBSCRIPTION/UPDATE");
export const deleteOne = createRoutine("SUBSCRIPTION/DELETE_ONE");
